import {useMutation} from '@tanstack/react-query';
import {queryClient} from 'infra/libs/react-query';
import {MUTATION_KEYS} from 'infra/libs/react-query/mutationKeys';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {postContractualTermAccept} from '../../services/postContractualTermAccept';

export const usePostContractualTermAcceptMutation = () =>
	useMutation({
		mutationKey: [MUTATION_KEYS.CONTRACTUAL_TERM_ACCEPT],
		mutationFn: postContractualTermAccept,
		onSuccess: response => {
			if (!response.sucess) return;

			queryClient.setQueriesData({queryKey: [QUERY_KEYS.CONTRACTUAL_TERM_PENDING]}, false);
		},
	});
